import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthProvider.jsx'
import ToastProvider from './components/toast/ToastProvider.jsx'
import CacheBuster from './components/CacheBuster.jsx'

import './styles/style.css'
import './styles/login.css'
import './styles/botones.css'
import './styles/animaciones.css'
import './styles/tablas.css'
import './styles/bootstrap-icons.min.css'
import './index.css'
import App from './App.jsx'

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) {
          return null
        }

        if (!isLatestVersion) {
          refreshCacheAndReload()
          return null
        }

        return (
          <BrowserRouter>
            <AuthProvider>
              <ToastProvider>
                <App />
              </ToastProvider>
            </AuthProvider>
          </BrowserRouter>
        )
      }}
    </CacheBuster>
  </StrictMode>
)
